export default {
  title: 'Tak, fordi du har indsendt dine oplysninger for at modtage betalinger',
  description:
    'Stripes gennemgang kan tage op til 48 timer. I mellemtiden kan du fortsætte med de næste trin. Vi giver dig besked på e-mail, så snart dine oplysninger er bekræftet.',
};
